<template>
	<!-- 顶部导航栏 - 完全对标源站 -->
	<div class="top-navigation" style="background: var(--nav-bg); padding: 8px 20px; display: flex; align-items: center; justify-content: space-between; transition: background-color 0.3s ease;">
		<!-- 左侧：Logo和功能按钮 -->
		<div style="display: flex; align-items: center; gap: 20px;">
			<!-- Logo区域 -->
			<div class="logo-section">
				<img src="@/assets/img/sax_logo.png" alt="Fodold" class="header-logo">
				<span class="logo-text">Fogold</span>
			</div>
			
			<!-- 显示控制按钮 -->
			<div style="display: flex; gap: 10px;">
				<button
					class="control-btn control-btn-active"
					disabled
				>
					{{ $t('Trading.productList') || '产品列表' }}
				</button>
				<button
					:class="showSubmitOrder ? 'control-btn control-btn-active' : 'control-btn'"
					@click="toggleSubmitOrder"
				>
					{{ $t('Trading.submitOrder') || '下单' }}
				</button>
			</div>

		<!-- 时间周期选择 -->
		<div style="display: flex; gap: 10px; align-items: center;">
			<div
				v-for="period in timePeriods"
				:key="period.value"
				:class="selectedPeriod === period.value ? 'period-active' : 'period-item'"
				@click="selectPeriod(period.value)"
			>
				{{ period.label }}
			</div>
			
		<!-- 指标按钮 -->
		<div
			:class="showIndicators ? 'period-active' : 'period-item'"
			@click="toggleIndicators"
		>
			{{ $t('Trading.indicator') || 'Indicator' }}
		</div>
	</div>
	
	<!-- K线图操作按钮 -->
	<div style="display: flex; gap: 8px; align-items: center; margin-left: 15px; padding-left: 15px; border-left: 1px solid var(--border-color);">
		<!-- 截图按钮 -->
		<button class="chart-action-btn" @click="handleScreenshot" :title="$t('Trading.screenshot') || '截图'">
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
				<circle cx="12" cy="13" r="4"></circle>
			</svg>
		</button>
		
		<!-- 放大按钮 - 横向放大 -->
		<button class="chart-action-btn" @click="handleZoomIn" :title="$t('Trading.zoomIn') || '放大'">
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<circle cx="11" cy="11" r="8"></circle>
				<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
				<line x1="11" y1="8" x2="11" y2="14"></line>
				<line x1="8" y1="11" x2="14" y2="11"></line>
			</svg>
		</button>
		
		<!-- 缩小按钮 - 横向缩小 -->
		<button class="chart-action-btn" @click="handleZoomOut" :title="$t('Trading.zoomOut') || '缩小'">
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<circle cx="11" cy="11" r="8"></circle>
				<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
				<line x1="8" y1="11" x2="14" y2="11"></line>
			</svg>
		</button>
		
		<!-- 全屏按钮 -->
		<button class="chart-action-btn" @click="handleFullscreen" :title="$t('Trading.fullscreen') || '全屏'">
			<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
			</svg>
		</button>
	</div>
</div>

		<!-- 右侧：语言切换和用户信息 -->
		<div style="display: flex; align-items: center; gap: 15px;">
				
			<!-- 理财按钮 -->
			<div style="margin-right: 15px;">
				<button class="finance-btn" @click="handleFinanceClick">
					{{ $t('Financial.title') || '理财' }}
				</button>
			</div>
			
			<!-- 贷款按钮 -->
			<!-- <div style="margin-right: 15px;">
				<button class="loan-btn" @click="handleLoanClick">
					{{ $t('loan.title') || '贷款' }}
				</button>
			</div> -->
			
			<!-- 划转按钮 -->
			<div style="margin-right: 15px;">
				<button class="transfer-btn" @click="handleTransferClick">
					{{ $t('transfer.title') || '划转' }}
				</button>
			</div>
			
			<!-- 关于我们按钮 -->
			<div style="margin-right: 15px;">
				<button class="about-btn" @click="handleAboutClick">
					{{ $t('navTab.aboutUs') || 'About Us' }}
				</button>
			</div>
			
 			<!-- APP下载按钮 -->
			<div style="margin-right: 15px;">
				<button class="app-download-btn" @click="handleAppDownloadClick">
					APP
				</button>
			</div>
			
		<!-- 黑夜模式开关 -->
		<div style="margin-right: 15px;">
			<button class="theme-toggle-btn" @click="handleDarkModeToggle">
				<!-- 太阳图标 (白天模式) -->
				<svg v-if="!darkMode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
					<path fill="currentColor" d="M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0zm543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0"></path>
				</svg>
				<!-- 月亮图标 (黑夜模式) -->
				<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
					<path fill="currentColor" d="M240.448 240.448a384 384 0 1 0 559.424 525.696 448 448 0 0 1-542.016-542.08 390.592 390.592 0 0 0-17.408 16.384zm181.056 362.048a384 384 0 0 0 525.632 16.384A448 448 0 1 1 405.056 76.8a384 384 0 0 0 16.448 525.696"></path>
				</svg>
			</button>
		</div>
			
			<!-- 语言切换按钮（弹窗式） -->
			<div style="position: relative;" data-language-button>
				<div 
					@click="handleLanguageToggle"
					class="language-switcher-btn"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<circle cx="12" cy="12" r="10"></circle>
						<line x1="2" y1="12" x2="22" y2="12"></line>
						<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
					</svg>
					<span style="font-weight: 500;">{{ currentLangName || 'Language' }}</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :style="{ transform: isLanguageSelectorOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }">
						<polyline points="6 9 12 15 18 9"></polyline>
					</svg>
				</div>

				<!-- 语言选择弹窗 -->
				<div v-if="isLanguageSelectorOpen" class="language-selector-popup" @click.stop>
					<!-- <div class="language-popup-title">{{ $t('navTab.languageTips') || '选择语言' }}</div> -->
					<div class="language-options">
						<div 
							v-for="(lang, index) in langList" 
							:key="index"
							class="language-option-item"
							:class="{ 'active': langIndex === index }"
							@click="handleLanguageSelect(index)"
						>
							<img :src="getLanguageIcon(lang.name)" :alt="lang.name" class="language-flag-icon" />
							<span>{{ lang.name }}</span>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 用户信息/登录按钮 -->
			<div v-if="isUserLoggedIn">
				<!-- 已登录：显示用户邮箱 - 可点击弹出账户弹窗 -->
				<div 
					class="user-email-clickable" 
					@click="handleAccountClick"
					style="color: var(--text-primary); font-size: 14px; cursor: pointer; padding: 5px 10px; border-radius: 4px; transition: all 0.3s;"
					@mouseenter="$event.target.style.background = '#f0f0f0'"
					@mouseleave="$event.target.style.background = 'transparent'"
				>
					{{ getUserInfo.email || getUserInfo.phone || 'User' }}
				</div>
			</div>
			<div v-else>
				<!-- 未登录：显示登录/注册按钮 -->
				<div style="display: flex; gap: 10px;">
					<button class="auth-btn login-btn" @click="handleLoginClick">
						{{ $t('login.btnLogin') || '登录' }}
					</button>
					<button class="auth-btn register-btn" @click="handleRegisterClick">
						{{ $t('login.register') || '注册' }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getParamByKey } from '@/api/market.js';

export default {
	name: 'TradingTopNav',
	props: {
		showSubmitOrder: {
			type: Boolean,
			default: false
		},
		selectedPeriod: {
			type: String,
			default: '1M'
		},
		showIndicators: {
			type: Boolean,
			default: false
		},
		isUserLoggedIn: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isLanguageSelectorOpen: false,
			appDownloadUrl: '' // APP下载链接
		};
	},
	mounted() {
		// 获取APP下载链接
		this.getAppDownloadUrl();
	},
	computed: {
		...mapState(['isPc', 'langList', 'langIndex', 'isLogin', 'token', 'darkMode']),
		...mapGetters(['getUserInfo']),
		
		// ✅ 检测是否为模拟账户
		isDemoAccount() {
			return this.isUserLoggedIn && (this.getUserInfo.isDemo === 1 || this.getUserInfo.isDemo === '1')
		},
		
	// 时间周期选项（支持国际化）
	timePeriods() {
		return [
			{ label: '1M', value: '1M', dateType: '1' },
			{ label: '5M', value: '5M', dateType: '5' },
			{ label: '15M', value: '15M', dateType: '15' },
			{ label: '30M', value: '30M', dateType: '30' },
			{ label: '1H', value: '1H', dateType: '60' },
			{ label: '1D', value: '1D', dateType: 'd' }
		];
	},
		
		// 当前语言名称
		currentLangName() {
			const name = this.langList && this.langList[this.langIndex] ? this.langList[this.langIndex].name : 'English';
			return name;
		}
	},
	methods: {
		// 切换下单面板
		toggleSubmitOrder() {
			this.$emit('toggle-submit-order');
		},
		
	// 选择时间周期
	selectPeriod(value) {
		this.$emit('select-period', value);
	},
	
	// 切换指标面板
	toggleIndicators() {
		this.$emit('toggle-indicators');
	},
	
	// K线图操作方法
	handleScreenshot() {
		this.$emit('chart-screenshot');
	},
	handleZoomIn() {
		this.$emit('chart-zoom-in');
	},
	handleZoomOut() {
		this.$emit('chart-zoom-out');
	},
	handleFullscreen() {
		this.$emit('chart-fullscreen');
	},
	
	// 切换语言选择器
	handleLanguageToggle() {
		this.isLanguageSelectorOpen = !this.isLanguageSelectorOpen;
		this.$forceUpdate();
	},
		
		// 选择语言
		handleLanguageSelect(index) {
			const lang = this.langList[index].value;
			this.$store.commit('SET_LANG', lang);
			this.isLanguageSelectorOpen = false;
		},
		
		// 根据语言名称获取对应的国旗图标URL
		getLanguageIcon(langName) {
			const countryMap = {
				'English': 'us',
				'简体中文': 'cn',
				'繁體中文': 'hk',
				'日本語': 'jp',
				'한국어': 'kr',
				'ไทย': 'th',
				'Tiếng Việt': 'vn',
				'français': 'fr',
				'Deutsche': 'de',
				'Español': 'es',
				'Italiano': 'it',
				'العربية': 'sa'
			};
			const countryCode = countryMap[langName] || 'us';
			return `https://flagcdn.com/w40/${countryCode}.png`;
		},
		
		// 切换黑夜模式
		handleDarkModeToggle() {
			this.$emit('toggle-dark-mode');
		},
		
		// 理财按钮点击
		handleFinanceClick() {
			this.$emit('finance-click');
		},
		
		// 贷款按钮点击
		handleLoanClick() {
			// ✅ 检查模拟账户
			if (this.isDemoAccount) {
				this.$message.warning(this.$t('account.demoAccountOperationForbidden') || '模拟账户禁止操作');
				return;
			}
			this.$emit('loan-click');
		},
		
		// 划转按钮点击
		handleTransferClick() {
			this.$emit('transfer-click');
		},
		
		// 关于我们按钮点击
		handleAboutClick() {
			this.$emit('about-click');
		},
		
		// 获取APP下载链接
		async getAppDownloadUrl() {
			try {
				const res = await getParamByKey('down_url');
				if (res && res.success && res.result && res.result.paramValue) {
					this.appDownloadUrl = res.result.paramValue;
				}
			} catch (error) {
				console.error('获取APP下载链接失败:', error);
			}
		},
		
	// APP下载按钮点击
	handleAppDownloadClick() {
		if (this.appDownloadUrl) {
			// ✅ 使用 window.open 在新窗口打开，避免影响当前页面
			window.open(this.appDownloadUrl, '_blank');
		}
		// ✅ 移除硬编码的提示，如果没有配置链接则不执行任何操作
	},
		
		// 账户点击
		handleAccountClick() {
			this.$emit('account-click');
		},
		
		// 登录点击
		handleLoginClick() {
			this.$emit('login-click');
		},
		
		// 注册点击
		handleRegisterClick() {
			this.$emit('register-click');
		}
	}
};
</script>

<style scoped>
/* 顶部导航样式 - 完全对标源站 */
.top-navigation {
	background: var(--nav-bg);
	padding: 8px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background-color 0.3s ease;
	position: relative;
	z-index: 10000;
}

/* Logo区域样式 */
.logo-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.header-logo {
	width: 32px;
	height: 32px;
	border-radius: 6px;
	object-fit: contain;
}

.logo-text {
	font-size: 20px;
	font-weight: 700;
	color: var(--text-primary);
	letter-spacing: -0.5px;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* 控制按钮样式 - 蓝色主题 */
.control-btn {
	padding: 8px 16px;
	font-size: 14px;
	font-weight: 600;
	color: var(--text-secondary);
	background: transparent;
	border: 1px solid var(--border-light);
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.control-btn:hover:not(:disabled) {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 2px 4px var(--primary-color-20);
}

.control-btn:active:not(:disabled) {
	background: var(--primary-dark);
	transform: translateY(0);
}

/* 激活状态的控制按钮 */
.control-btn-active {
	color: #ffffff;
	background: var(--primary-color, #0156DC);
	border: none;
	box-shadow: 0 2px 4px var(--primary-color-20);
}

.control-btn-active:hover:not(:disabled) {
	background: var(--primary-dark);
	box-shadow: 0 2px 4px var(--primary-color-20);
}

/* 禁用状态的按钮 */
.control-btn:disabled {
	cursor: not-allowed;
	opacity: 1;
}

/* 时间周期样式 - 蓝色主题 */
.period-item {
	padding: 8px 16px;
	font-size: 14px;
	font-weight: 500;
	color: var(--text-secondary);
	background: transparent;
	border: 1px solid transparent;
	border-radius: 6px;
	cursor: pointer;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	user-select: none;
	transition: all 0.2s ease;
}

.period-item:hover {
	background: #f8f9fa;
	color: var(--primary-color, #0156DC);
}

.period-active {
	padding: 8px 16px;
	font-size: 14px;
	font-weight: 600;
	color: #ffffff;
	background: var(--primary-color, #0156DC);
	border: 1px solid var(--primary-color, #0156DC);
	border-radius: 6px;
	cursor: pointer;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	user-select: none;
	box-shadow: 0 2px 4px var(--primary-color-20);
}

/* 语言切换按钮样式 */
.language-switcher-btn {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 12px;
	background: transparent;
	border: 1px solid var(--border-light);
	border-radius: 6px;
	cursor: pointer;
	transition: all 0.2s ease;
	color: var(--text-primary);
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	user-select: none;
}

.language-switcher-btn:hover {
	background: var(--primary-color-15);
	border-color: var(--primary-color-20);
	box-shadow: 0 2px 8px var(--primary-color-20);
}

.language-switcher-btn:active {
	transform: scale(0.98);
}

/* 语言选择弹窗 */
.language-selector-popup {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	min-width: 200px;
	background: var(--card-bg);
	border: 1px solid var(--border-light);
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	z-index: 100001 !important;
	overflow: hidden;
}

.language-popup-title {
	padding: 12px 16px;
	font-size: 14px;
	font-weight: 600;
	color: var(--text-primary);
	background: var(--bg-secondary);
	border-bottom: 1px solid var(--border-light);
}

.language-options {
	max-height: 300px;
	overflow-y: auto;
}

.language-option-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	cursor: pointer;
	transition: all 0.2s ease;
	color: var(--text-primary);
	font-size: 14px;
}

.language-option-item:hover {
	background: var(--primary-color-10);
}

.language-option-item.active {
	background: var(--primary-color-15);
	color: var(--primary-color, #0156DC);
	font-weight: 600;
}

.language-flag-icon {
	width: 24px;
	height: 16px;
	border-radius: 2px;
	object-fit: cover;
}

/* 登录/注册按钮样式 */
.auth-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.login-btn {
	background: transparent;
	color: var(--primary-color, #0156DC);
	border: 1px solid var(--primary-color, #0156DC);
}

.login-btn:hover {
	background: var(--primary-color-10);
	transform: translateY(-1px);
	box-shadow: 0 2px 4px var(--primary-color-20);
}

.register-btn {
	background: var(--primary-color, #0156DC);
	color: white;
}

/* K线图操作按钮样式 */
.chart-action-btn {
	width: 32px;
	height: 32px;
	padding: 0;
	border: none;
	background: transparent;
	color: var(--text-secondary);
	border-radius: 6px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
}

.chart-action-btn:hover {
	background: var(--hover-bg);
	color: var(--text-primary);
	transform: translateY(-1px);
}

.chart-action-btn:active {
	transform: translateY(0);
}

.chart-action-btn svg {
	width: 18px;
	height: 18px;
}

.register-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 理财按钮样式 */
.finance-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	background: var(--primary-color, #0156DC);
	color: white;
}

.finance-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 贷款按钮样式 */
.loan-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	background: var(--primary-color, #0156DC);
	color: white;
}

.loan-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 划转按钮样式 */
.transfer-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	background: var(--primary-color, #0156DC);
	color: white;
}

.transfer-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 关于我们按钮样式 */
.about-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	background: var(--primary-color, #0156DC);
	color: white;
}

.about-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* APP下载按钮样式 */
.app-download-btn {
	padding: 8px 20px;
	border: none;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	background: var(--primary-color, #0156DC);
	color: white;
}

.app-download-btn:hover {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 8px var(--primary-color-20);
}

/* 黑夜模式切换按钮 - 太阳/月亮图标 */
.theme-toggle-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background: transparent;
	color: var(--primary-color, #0156DC);
	cursor: pointer;
	transition: all 0.3s ease;
}

.theme-toggle-btn svg {
	width: 20px;
	height: 20px;
	transition: transform 0.3s ease;
}

.theme-toggle-btn:hover {
	background: var(--primary-color-10);
	transform: scale(1.1);
}

.theme-toggle-btn:hover svg {
	transform: rotate(20deg);
}

.theme-toggle-btn:active {
	transform: scale(0.95);
}

/* 用户邮箱可点击样式 */
.user-email-clickable {
	color: var(--text-primary);
	font-size: 14px;
	cursor: pointer;
	padding: 5px 10px;
	border-radius: 4px;
	transition: all 0.3s;
}
</style>

<style>
/* 全局样式：确保语言选择器在最顶层 */
[data-language-button] {
	z-index: 100002 !important;
	position: relative;
}

.language-selector-popup {
	z-index: 100001 !important;
}
</style>

